exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/group-right-sidebar/group-right-sidebar.component.css
// module id = ../../../../../src/app/home/group-right-sidebar/group-right-sidebar.component.css
// module chunks = common